import styled from "styled-components";
import { FieldSet, Input } from "../../../../../App/Common/Components/FormComponents";
import { FormContainer } from "../../../../pages/CourseAuthor/FormElements";

export const FlexFormContainer = styled(FormContainer as any)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 3rem;
`;

export const SeparatorFieldSet = styled(FieldSet as any)`
  color: ${props => props.theme.colors.darkgrey4};
  border-radius: 5px;
  display: inline-block;
  position: relative;
  height: 3.5em;
  width: 10em;
  min-width: 3em;
  padding: 0;
  margin: 0;

  &::after {
    content: "px";
    position: absolute;
    color: ${({ theme }) => theme.colors.textDarkBlue};
    top: 0.1em;
    transition: all 0.05s ease-in-out;
  }
`;

export const ColorFieldSet = styled(FieldSet as any)`
  width: 10em;
  height: 3.5em;
  color: ${props => props.theme.colors.darkgrey4};
  background-color: transparent;
  padding: 0;
`;

export const SeparatorErrorMessage = styled.p`
  color: red;
  margin: 0;
`;

export const PreviewBoxContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PreviewBox = styled.div<{ height: number }>`
  width: 90%;
  height: ${props => props.height}px;
  border: 1px solid ${props => props.theme.colors.grey};
  border-radius: 0.5rem;
  background: ${props => props.color};
`;

export const SpacerInput = styled(Input as any)`
  border: none;
  background: ${props => props.theme.colors.lightgrey3};
  font-size: ${({ theme }) => theme.fontSizes.regular};
  text-align: right;
  width: 75%;
  color: ${({ theme }) => theme.colors.textDarkBlue};

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -moz-appearance: textfield;
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const ColourInput = styled(Input)`
  border: 1px solid #c2c2c2;
  height: 3.5rem;
  width: 50%;
  min-width: 100px;
  border-radius: 5px;
`;
